import { createKeyvalStorage } from '../lib/keyval.storage'
import { createLocalStorage } from '$logic/lib/local.storage'

export const [authStorage, authReducer] = createLocalStorage<Auth>('auth')

export const userJwtStorage = createKeyvalStorage<Auth>('user-jwt')

export const contentJwtStorage = createKeyvalStorage<Record<string, string>>(
  'content-jwt',
)
